import fries from '../../assets/img/fries.svg';
import sandwich from '../../assets/img/sandwich.svg';
import hotDog from '../../assets/img/hot-dog.svg';

const data = [
  {
    title: 'French Fries',
    text: 'According to an old family recipe',
    score: 4.8,
    image: fries,
  },
  {
    title: 'Sandwiches',
    score: 5.0,
    image: sandwich,
  },
  {
    title: 'Hot dogs',
    score: 4.9,
    image: hotDog,
  },
];

export default data;
